export default __webpack_public_path__ + "static/media/TITULOS_16.43088e01.png";